export default "__VITE_ASSET__Cub_dSTx__"